import { forwardRef } from 'react';
import { Box, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import cssVars from '@figma/fpl-tokens/css-vars';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { color } from '@/colors';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import type { SxProps, Theme } from '@/UI/theme.exports';

export const Flex = styled('div')({
  display: 'flex',
});
Flex.displayName = 'Flex';

export const FlexCol = styled(Flex)({
  display: 'flex',
  flexDirection: 'column',
});
FlexCol.displayName = 'FlexCol';

export const FlexCenHor = styled(Flex)({
  justifyContent: 'center',
});
FlexCenHor.displayName = 'FlexCenHor';

export const FlexCenVer = styled(Flex)({
  alignItems: 'center',
});
FlexCenVer.displayName = 'FlexCenVer';

export const FlexCenVerSpaceBetween = styled(Flex)({
  alignItems: 'center',
  justifyContent: 'space-between',
});
FlexCenVerSpaceBetween.displayName = 'FlexCenVerSpaceBetween';

export const FlexCenHorVer = styled(FlexCenHor)({
  alignItems: 'center',
});
FlexCenHorVer.displayName = 'FlexCenHorVer';

export const FlexColCenHor = styled(FlexCol)({
  alignItems: 'center',
});
FlexColCenHor.displayName = 'FlexColCenHor';

export const FlexColCenVer = styled(FlexCol)({
  justifyContent: 'center',
});
FlexColCenVer.displayName = 'FlexColCenVer';

export const FlexColCenHorVer = styled(FlexColCenHor)({
  alignItems: 'center',
  justifyContent: 'center',
});
FlexColCenHorVer.displayName = 'FlexColCenHorVer';

const AppPaperRoot = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: token.bg,
  border: `1px solid ${color.White04_T}`,
}));
AppPaperRoot.displayName = 'AppPaperRoot';

export const AppPaper = forwardRef<HTMLDivElement, BoxProps>(function AppPaper({ sx, ...props }, ref) {
  const isFplMigrationEnabled = useFplMigrationFlag();
  const sxArray: SxProps<Theme> = Array.isArray(sx) ? sx : sx ? [sx] : [];
  return (
    <AppPaperRoot
      ref={ref}
      // fpl-migration: swap the paper surface to the `bg` token; caller `sx` still wins on top.
      sx={[isFplMigrationEnabled ? { backgroundColor: cssVars.color.bg } : false, ...sxArray]}
      {...props}
    />
  );
});
AppPaper.displayName = 'AppPaper';
